import { ToastAlertTypes } from '@genial/components';
import * as zod from 'zod';

import { TableHeadItemRecurse } from '../../../components/TableHead';
import { OrderHistoryType } from '../../../store/orderHistory/types';

export type OrderHistoryItemProps = OrderHistoryType;

export interface OrderHistoryTableProps {
  isLoading: {
    all: boolean;
    more: boolean;
  };
  data: {
    orders: OrderHistoryItemProps[];
  };
  invalidColumns?: boolean;
  listMoreOrders: () => void;
  isMobile: boolean;
  searchTerm: string;
  hasFilter: boolean;
}

export const ordersHistoryTableHead: TableHeadItemRecurse[] = [
  { title: '#', flex: 0.3 },
  { title: 'ID Ordem', flex: 0.7 },
  { title: 'ID Cesta', flex: 0.8 },
  { title: 'Tipo', orderValue: 'side', flex: 0.6 },
  { title: 'Data de Envio', orderValue: 'orderDate', flex: 0.6 },
  { title: 'Cliente', flex: 1 },
  { title: 'Produto', orderValue: 'marketType', flex: 0.8 },
  { title: 'Total estimado', orderValue: 'requestedAmount', flex: 0.7 },
  { title: 'Status', flex: 0.8 },
  { title: '', flex: 0.8 },
];

export type SearchFormData = zod.infer<typeof formSearchSchema>;

export const formSearchSchema = zod.object({
  searchTerm: zod
    .string({ required_error: 'Campo obrigatório' })
    .min(2, 'Campo deve ter no mínimo 2 caracteres')
    .refine((value) => value.trim() !== '', {
      message: 'Campo não pode consistir apenas de espaços em branco',
    }),
});

export const defaultErrorMessage: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Opa! Algo parece errado.',
  'Ocorreu um erro ao carregar o Portal,\nverifique sua conexão com a internet e\ntente novamente em instantes.',
];

export const defaultPagination = { page: 1, limit: 40 };

export const messageError = '--';
